import { Modal, Stack, Typography } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CalendarImg from "assets/calendar.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function ModalConfirmationEmail({ open, onClose }) {
  const router = useHistory();

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal Width={"593px"} borderRadius={"8px"} p={"48px 40px"}>
        <Stack justifyContent={"center"} alignItems={"center"}>
          <Typography
            fontSize={"32px"}
            fontWeight={700}
            color="#053462"
            mb={"64px"}
          >
            Vamos te lembrar de cancelar seu cadastro na data escolhida!
          </Typography>
          <img src={CalendarImg} height={"175px"} width={"197px"} />
          <Typography
            fontSize={"28px"}
            fontWeight={700}
            color="#2CABF9"
            alignSelf={"flex-end"}
            mt={"64px"}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              onClose();
              router.push("/address-list");
            }}
          >
            Ok
          </Typography>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
